<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4></h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <form>
    <div class="form-group" *ngIf="siteFormsOptions.length && isCheckOnModal" [formGroup]="form">
      <label>Select Compulsory Check-On Site Form</label>
      <p-dropdown
        class="form-control"
        formControlName="siteFormCheckOn"
        [options]="siteFormsOptions"
        optionLabel="label"
        required="false"
        [style]="{ width: '100%' }"
        filter="true">
      </p-dropdown>
    </div>
    <div class="form-group" *ngIf="siteFormsOptions.length && !isCheckOnModal" [formGroup]="form">
      <label>Select Compulsory Check-Off Site Form</label>
      <p-dropdown
        class="form-control"
        formControlName="siteFormCheckOff"
        [options]="siteFormsOptions"
        optionLabel="label"
        required="false"
        [style]="{ width: '100%' }"
        filter="true">
      </p-dropdown>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onSubmit()" [disabled]="!form.valid || !form.dirty" class="btn btn-sm btn-success">Save</button>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
